module.exports = __webpack_public_path__ + "static/media/culture.e13b005e.jpg";